import React, { useState } from "react";
import astronaut01 from "../../assets/arvix/astronaut_01.png";
import astronaut02 from "../../assets/arvix/astronaut_02.png";
import "./AnimatedAstronaut.css";

const AnimatedAstronaut = ({ type = "01", className = "", delay = 0 }) => {
  const astronautImage = type === "01" ? astronaut01 : astronaut02;
  const [imageError, setImageError] = useState(false);
  
  const handleImageError = () => {
    setImageError(true);
  };
  
  // Create a simple SVG fallback instead of external placeholder
  const fallbackSvg = `data:image/svg+xml,${encodeURIComponent(`
    <svg width="100" height="100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" fill="#f3f4f6"/>
      <circle cx="50" cy="35" r="12" fill="#e31c25"/>
      <rect x="35" y="55" width="30" height="25" rx="5" fill="#e31c25"/>
      <text x="50" y="90" text-anchor="middle" font-family="Montserrat, sans-serif" font-size="8" fill="#6b7280">Astronaut</text>
    </svg>
  `)}`;
  
  return (
    <div className={`astronaut-container ${className}`} style={{ animationDelay: `${delay}s` }}>
      <img
        src={imageError ? fallbackSvg : astronautImage}
        alt={`Astronaut ${type}`}
        className="astronaut-image"
        onError={handleImageError}
      />
    </div>
  );
};

export default AnimatedAstronaut;
